import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { WarningRounded } from "@mui/icons-material";

function ComingSoon() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        py={3}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Card
          sx={{
            p: 6,
            textAlign: "center",
            width: "100%",
            borderRadius: 4,
          }}
        >
          <SoftBox display="flex" justifyContent="center" mb={2}>
            <WarningRounded sx={{ fontSize: 100, color: "warning.main" }} />
          </SoftBox>

          <SoftTypography variant="h4" fontWeight="bold" mb={1}>
            This page isn’t available yet
          </SoftTypography>

          <SoftTypography variant="body2" color="text.secondary">
            We’re working hard to bring this feature to you soon.
          </SoftTypography>
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ComingSoon;
